export default [
    {
        path: 'egresos',
        name: 'SucursalEgresos',
        component: () => import('@/views/egresos/egresos.vue'),
    },
    {
        path: 'egresos/gastos/nuevo',
        name: 'SucursalEgresosNuevo',
        component: () => import('@/views/empresa/sucursales/egresos/GastosSucursalRegistrar.vue'),
    },
    {
        path: 'egresos/gastos',
        name: 'SucursalEgresosGastos',
        redirect: { name: 'SucursalEgresosGastosCategoria' },
        component: () => import('@/views/empresa/sucursales/egresos/GastosSucursalHome.vue'),
        children: [

            { path: '', name: 'SucursalEgresosGastosCategoria', component: () => import('@/components/egresos/GastosPorCategoriaList.vue') },

            { path: 'detail', name: 'SucursalEgresosGastosList', component: () => import('@/views/empresa/sucursales/egresos/GastosSucursalList.vue') },
        ],
    },
    {
        path: 'egreso/gastos/nuevo',
        name: 'empresa.egreso.gasto.nuevo',
        component: () => import('@/views/empresa/sucursales/egresos/GastosSucursalRegistrar.vue'),
    },
    {
        path: 'egresos/categorias/:padre',
        name: 'SucursalEgresosCategoriaTree',
        component: () => import('@/components/egresos/categorias/EgresoCategoriasTree.vue'),
    },
    {
        path: 'egresos/categorias',
        name: 'SucursalEgresosCategoria',
        component: () => import('@/views/egresos/EgresosCategoria.vue'),
    },
    {
        path: 'egresos/:id',
        name: 'SucursalEgresosActualizar',
        component: () => import('@/views/empresa/sucursales/egresos/GastoSucursalEditar.vue'),
    },
    {
        path: 'egresos/tipo-egreso',
        name: 'SucursalEgresosTipoIngresoEgreso',
        component: () => import('@/views/empresa/sucursales/egresos/EgresosTipos.vue'),
    },
    {
        path: 'egreso/buzon',
        name: 'SucursalEgresoBuzon',
        redirect: { name: 'SucursalEgresoBuzonHome' },
        component: () => import('@/views/egresos/buzon/buzon.vue'),
        children: [
            {
                path: '',
                name: 'SucursalEgresoBuzonHome',
                component: () => import('@/views/egresos/buzon/buzon.home.vue'),
            },
            {
                path: 'registrar',
                name: 'SucursalEgresoBuzonRegistrar',
                component: () => import('@/views/egresos/buzon/buzon.registrar.vue'),
            },
            {
                path: 'historial',
                name: 'SucursalEgresoBuzonHistorial',
                component: () => import('@/views/egresos/buzon/buzon.historial.vue'),
            },
        ],
    },
];
